import { Capacitor } from '@capacitor/core';

/** Запущено внутри оболочки телефона (iOS/Android), а не в обычном браузере. */
export function isNative(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

export function platformName(): string {
  try {
    return Capacitor.getPlatform();
  } catch {
    return 'web';
  }
}
